import { Selector } from '@ngrx/store';
import * as RouterStoreSelectors from './router.selector';

export const selectCurrentGroupId: Selector<object, string | null> = RouterStoreSelectors.selectRouterParam('g');

export const selectCurrentUserId: Selector<object, string | null> = RouterStoreSelectors.selectRouterParam('u');
